import { useCallback } from 'react'

export function useHubSpotModal() {
    const showHsModal = useCallback(() => {
        const specificDiv = document.getElementById(
            'hs-interactives-modal-overlay'
        )

        const divs = document.querySelectorAll("div[id^='hs-overlay-cta-']")
        if (divs.length > 0 && specificDiv) {
            specificDiv.style.display = 'block'
            specificDiv.className = 'go1632949049 go2512015367'
            divs.forEach((div) => {
                const htmlDiv = div as HTMLElement
                htmlDiv.style.display = 'block'
                htmlDiv.className =
                    'go4194603687 hs-cta-embed__loaded go4258295619'
            })
        }
    }, [])

    const hideHsModal = useCallback(() => {
        const hideElements = () => {
            const specificDiv = document.getElementById(
                'hs-interactives-modal-overlay'
            )
            const divs = document.querySelectorAll("div[id^='hs-overlay-cta-']")
            if (specificDiv && divs.length > 0) {
                specificDiv.style.display = 'none'
                specificDiv.className = 'go1632949049'
                divs.forEach((div) => {
                    const htmlDiv = div as HTMLElement
                    htmlDiv.style.display = 'none'
                    htmlDiv.className = 'go4194603687 hs-cta-embed__loaded'
                })
                return true
            }
            return false
        }

        if (hideElements()) {
            return
        }

        const observer = new MutationObserver(() => {
            if (hideElements()) {
                observer.disconnect()
            }
        })

        observer.observe(document.body, { childList: true, subtree: true })
    }, [])

    return { showHsModal, hideHsModal }
}

export default useHubSpotModal
